/**
 * The server refuses a twoFactorEnabled account without totpCode with 403
 * and "Two-factor authentication code is required" (routes/auth/login.ts).
 * A wrong code is 401 "Invalid 2FA code" — that stays an error for retry.
 */
export function isTwoFactorRequired(err: unknown): boolean {
  if (!(err instanceof Error)) return false;
  const status =
    'status' in err && typeof (err as { status: unknown }).status === 'number'
      ? (err as { status: number }).status
      : undefined;
  if (status !== undefined && status !== 403) return false;
  return /two-factor/i.test(err.message);
}
